export default function () {
  const widgetName = 'cardWidget';
  const widgetOpts = cardWidgetOpts;

  const isMobile = window.innerWidth <= 800;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: isMobile ? ['all'] : [],
    maxItemsVisible: 6,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: true,
    cardWidgetLoaded: function (data) {
      const widgetCount = data.items.length;
      if (widgetCount == 0) {
        $(`#${widgetName}`).remove();
      } else {
        addButtonClass(widgetName);
        createOverlay(widgetName);
        optimizeLinks(widgetName, data);
      }
    },
  });
}

// Add class to style widget buttons
function addButtonClass(widgetName) {
  $(`#${widgetName} .buttonwrap a`).addClass('button');
}

// Create an overlay for animation effects
function createOverlay(widgetName) {
  $(`#${widgetName} .card-widget-item .image-container`).each(function () {
    $(this).find('.card-content').before('<div class="overlay"></div>');
  });
}

// Remove buttonwrap if empty and href if there is no link
function optimizeLinks(widgetName, data) {
  $(`#${widgetName} .buttonwrap`).each(function () {
    if ($.trim($(this).html()) === '') {
      $(this).remove();
    }
  });

  $(`#${widgetName} .card-widget-item`).each(function (index) {
    if (!data.items[index]?.URL) {
      $(this).removeAttr('href');
    }
  });
}
